import { render, staticRenderFns } from "./CreateWorkflowGroup.vue?vue&type=template&id=e5213c06&scoped=true"
import script from "./CreateWorkflowGroup.vue?vue&type=script&lang=js"
export * from "./CreateWorkflowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5213c06",
  null
  
)

export default component.exports